import Raven from 'raven-js';
import { createTracker } from 'usage-tracker';
import events from '../../../events.yaml';
const APP_NAME = 'notification-station';
let NotificationsUsageTracker;
function createNotificationsTrackingClient() {
  return createTracker({
    events,
    properties: {
      namespace: APP_NAME
    }
  });
}
export function setupNotificationsUsageTracker() {
  NotificationsUsageTracker = createNotificationsTrackingClient();
}
export const getNotificationsUsageTracker = () => NotificationsUsageTracker || createNotificationsTrackingClient();
export const trackNotificationUsage = (eventKey, properties) => {
  if (!NotificationsUsageTracker) {
    Raven.captureException(new Error('No NotificationUsageTracker instantiated'));
  }
  NotificationsUsageTracker.track(eventKey, properties);
};